export default theme => ({
  content: {
    overflow: 'hidden'
  },
  button: {
    marginLeft: theme.spacing(1),
    '& .MuiSvgIcon-root': {
      width: 20,
      height: 20
    }
  },
  popperPaper: {
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    maxHeight: 'calc(100vh - 75px)',
    overflow: 'auto'
  },
  popperTitle: {
    fontWeight: 500,
    paddingBottom: theme.spacing(1.5)
  }
});
